import React from "react";

export default function Accessibility() {
  return (
    <main className="container">
      <section className="request">
        <h2>Accessibility Statement</h2>
        <p className="sub">
          We are committed to providing a website that is accessible to the
          widest possible audience.
        </p>

        <div className="grid-1">
          <h3 style={{ color: "var(--ua-blue)" }}>Our Commitment</h3>
          <p>
            We aim to follow generally recognized accessibility standards (such
            as WCAG 2.1 AA) where practical.
          </p>

          <h3 style={{ color: "var(--ua-blue)" }}>Feedback</h3>
          <p>
            If you experience any difficulty using our site, please contact us
            and we’ll work with you to provide the information or service you
            need.
          </p>

          <div className="card" style={{ maxWidth: 900 }}>
            <div className="card-body">
              <h3>Contact for Accessibility Support</h3>
              <p>Email: <strong>service@azfacilitymanagement.com</strong></p>
              <p>Include: the page URL and a brief description of the issue.</p>
            </div>
          </div>

          <h3 style={{ color: "var(--ua-blue)" }}>Ongoing Improvements</h3>
          <p>
            Accessibility is an ongoing effort. We periodically review pages and
            features and make improvements when possible.
          </p>
        </div>
      </section>
    </main>
  );
}